import Vue from 'vue'
import VueRouter, {Route, RouteConfig} from 'vue-router'
import HomePage from './home/HomePage.vue'
import RoomPage from './rooms/RoomPage.vue'
import {Position, PositionResult} from "vue-router/types/router"

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {path: '/', component: HomePage},
  {path: '/rooms/:id', component: RoomPage},
]

const router = new VueRouter({
  routes,
  scrollBehavior(
    to: Route, from: Route, savedPosition: (Position | void)
  ): (PositionResult | Promise<PositionResult> | undefined | null) {
    if (savedPosition) {
      return savedPosition
    } else if (to.hash) {
      return {selector: to.hash}
    } else {
      return {x: 0, y: 0}
    }
  },
})

export default router
